<template>
  <div class="container">
    <div class="formbox">
<!--      <el-button-->
<!--        class="btn_e6a23c"-->
<!--        style="margin-bottom: 20px"-->
<!--        @click="saveBtn()"-->
<!--      >-->
<!--        保 存-->
<!--      </el-button>-->
<!--      <el-button-->
<!--        class="btn_e6a23c"-->
<!--        style="margin-bottom: 20px"-->
<!--        @click="saveBtn2()"-->
<!--      >-->
<!--        保存并审核-->
<!--      </el-button>-->
      <el-form
        :inline="true"
        label-position="right"
        label-width="100px"
        :model="datas"
        class="demo-form-inline formDisplay"
      >
        <!-- <el-form-item label="单据编号:" class="queryItem1">
          <el-input
            v-model="datas.listCode"
            placeholder=""
            disabled
            class="input"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="单据类型:" class="queryItem1">
          <el-select
              v-model="documentStatus"
              placeholder="请选择"
              class="input"
              filterable
              clearable
              @visible-change="visibleChange($event, 1)"
              @change="changeDocumentStatus"
          >
            <el-option
                v-for="item in documentStatusOptionsList"
                :key="item.documentStatus"
                :label="item.documentStatusShow"
                :value="item.documentStatus"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="来源单号:" class="queryItem1">

          <el-select
              v-model="documentNumber"
              placeholder="请选择"
              class="input"
              filterable
              clearable
              @visible-change="visibleChange($event, 2)"
              @change="changeDocumentNumber"
              remote
              :remote-method="(val) => getDocumentBillOptionsList(val)"
          >
            <el-option
                v-for="item in documentBillOptionsList"
                :key="item.documentNumber"
                :label="item.billNumber"
                :value="item.documentNumber"
            >
            </el-option>
          </el-select>

<!--          <el-input-->
<!--            v-model="datas.documentNumber"-->
<!--            placeholder=""-->
<!--            class="input"-->
<!--          ></el-input>-->
        </el-form-item>
        <el-form-item label="会员号:" class="queryItem1">
          <el-input
            v-model="datas.memberId"
            placeholder=""
            disabled
            class="input"
          ></el-input>
        </el-form-item>
        <el-form-item label="会员名称:" class="queryItem1">
          <el-input
            v-model="datas.nickName"
            placeholder=""
            disabled
            class="input"
          ></el-input>
        </el-form-item>
        <el-form-item label="仓库:" class="queryItem1">
          <el-input
            v-model="datas.storageName"
            placeholder=""
            disabled
            class="input"
          ></el-input>
        </el-form-item>
        <el-form-item label="目的地邮编:" class="queryItem1">
          <el-input
            v-model="datas.postCode"
            placeholder=""
            disabled
            class="input"
          ></el-input>
        </el-form-item>
        <el-form-item label="目的地:" class="queryItem1">
          <el-input
            v-model="datas.country"
            placeholder=""
            disabled
            class="input"
          ></el-input>
        </el-form-item>
        <el-form-item label="渠道:" class="queryItem1">
          <el-input
            v-model="datas.channelName"
            placeholder=""
            disabled
            class="input"
          ></el-input>
        </el-form-item>
        <el-form-item label="打包件数:" class="queryItem1">
          <el-input
            v-model="datas.sumCount"
            placeholder=""
            disabled
            class="input"
          ></el-input>
        </el-form-item>
        <el-form-item label="打包重量:" class="queryItem1">
          <el-input
            v-model="datas.sumWeight"
            placeholder=""
            disabled
            class="input"
          ></el-input>
        </el-form-item>
        <el-form-item label="打包体积:" class="queryItem1">
          <el-input
            v-model="datas.sumVolume"
            placeholder=""
            disabled
            class="input"
          ></el-input>
        </el-form-item>
        <el-form-item label="材积除:" class="queryItem1">
          <el-input
            v-model="datas.divisor"
            placeholder=""
            disabled
            class="input"
          ></el-input>
        </el-form-item>
        <el-form-item label="材积:" class="queryItem1">
          <el-input
            v-model="datas.dataVolume"
            placeholder=""
            disabled
            class="input"
          ></el-input>
        </el-form-item>
        <el-form-item label="结算重量:" class="queryItem1">
          <el-input
            v-model="datas.billingWeight"
            placeholder=""
            disabled
            class="input"
          ></el-input>
        </el-form-item>
        <el-form-item label="标准运费:" class="queryItem1">
          <el-input
            v-model="datas.standardFree"
            placeholder=""
            disabled
            class="input"
          ></el-input>
        </el-form-item>
        <el-form-item label="转单号:" class="queryItem1">
          <el-input
            v-model="datas.channelNumber"
            disabled
            placeholder=""
            class="input"
          ></el-input>
        </el-form-item>
        <el-form-item label="渠道代理:" class="queryItem1">
          <el-input
              v-model="datas.agentName"
              disabled
              placeholder=""
              class="input"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="其他费用:"
          disabled
          class="queryItem1 otherFee"
        >
          <!--          @click.native="otherDia"-->
          <el-input
            v-model="datas.otherFree"
            placeholder="请选择"
            readonly
            class="input"
          ></el-input>
        </el-form-item>

        <el-form-item label="修改运费:" class="queryItem1">
          <el-input
              disabled
            v-model="datas.updateFreight"
            placeholder="请输入"
            class="input"
          ></el-input>
        </el-form-item>
        <el-form-item label="应收合计:" class="queryItem1">
          <el-input
            v-model="datas.totalReceivable"
            placeholder=""
            disabled
            class="input"
          ></el-input>
          <!-- </el-form-item>
          <el-form-item label="" class="queryItem1" style="border:none"> -->
        </el-form-item>
        <el-form-item
          label="打包备注:"
          class="queryTextare"
          style="width: 100%"
        >
          <el-input
            type="textarea"
            rows="2"
            v-model="datas.packComment"
            disabled
            class="inputtext"
          ></el-input>
        </el-form-item>
      </el-form>

      <div class="jy-line-container">
        <AngleDouble title="财务信息">
          <div class="button-ground">
            <el-button class="jy-button" type="primary" @click="onAddFeiYong"
            >添加费用</el-button
            >
            <!-- <el-button class="jy-button" @click="onSaveCaiwu">保存</el-button> -->
            <el-button class="jy-button" @click="onCaiwuQdSp()">审核</el-button>
            <el-button class="jy-button" @click="onCaiwuQxSp()"
            >取消审核</el-button
            >
          </div>
          <div class="table-ground" style="margin-top: 20px">
            <el-table
                class="jy-common-table"
                header-align="center"
                border
                stripe
                :highlight-current-row="true"
                style="width: 100%"
                :data="financialInformationTable"
                @selection-change="handleSelectionChange"
                show-summary
            >
              <el-table-column
                  fixed="left"
                  align="center"
                  label="序号"
                  type="index"
                  width="60"
              ></el-table-column>
              <el-table-column fixed="left">
                <el-table-column type="selection" width="55" align="center" />
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  align="center"
                  prop="itemCategoryName"
                  label="费项类型"
                  width="100"
              >
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  align="center"
                  prop="itemServiceName"
                  label="费项"
                  width="60"
              >
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  align="center"
                  prop="unitPrice"
                  label="单价"
                  width="60"
              >
              </el-table-column>
              <el-table-column
                  show-overfslow-tooltip
                  align="center"
                  prop="amount"
                  label="总价"
                  width="60"
              >
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  align="center"
                  prop="currency"
                  label="币种"
                  width="60"
              >
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  align="center"
                  prop="objectStatus"
                  label="结算对象类型"
                  width="140"
              >
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  align="center"
                  prop="objectName"
                  label="结算对象"
                  width="100"
              >
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  align="center"
                  prop="paymentMethod"
                  label="付款方式"
                  width="100"
              >
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  align="center"
                  prop="isPostingShow"
                  label="审核状态"
                  width="100"
              >
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  align="center"
                  prop="remarks"
                  label="备注"
              >
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  align="center"
                  prop="updateUser"
                  label="操作人"
                  width="80"
              >
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  align="center"
                  prop="updateTime"
                  label="操作时间"
              >
              </el-table-column>
              <el-table-column
                  align="center"
                  label="操作"
                  fixed="right"
                  width="230"
              >
                <template #default="scope">
                  <el-button
                      v-if="pageStatus != 'readonly' && scope.row.isPosting == 0"
                      link
                      @click="onYsfyEditFun(scope, scope.$index)"
                  >编辑</el-button
                  >
                  <el-button
                      v-if="pageStatus != 'readonly' && scope.row.isPosting == 0"
                      link
                      @click="onCaiwuQdSp(scope)"
                  >审核</el-button
                  >
                  <el-button
                      v-if="pageStatus != 'readonly' && scope.row.isPosting == 1"
                      link
                      @click="onCaiwuQxSp(scope)"
                  >取消审核</el-button
                  >
                  <el-popconfirm
                      title="确定删除该行数据吗"
                      @confirm="delGoods(scope)"
                      v-if="pageStatus != 'readonly' && scope.row.isPosting == 0"
                  >
                    <template #reference>
                      <el-button link>删除</el-button>
                    </template>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </AngleDouble>
      </div>

      <!--  添加/编辑费用 -->
      <Dialog
          :show="dialogVisible"
          class="dialog-padding-container"
          :title="feiYongTit"
          @onCancel="addPayableCancel"
          @onConfirm="addPayableConfirm"
      >
        <el-form
            :model="addPayableInfo"
            :rules="addPayableInfoRules"
            label-width="150px"
            label-position="right"
        >
          <el-row :gutter="20">
            <el-col :span="20">
              <objectComponentsN
                  label="结算对象："
                  :objectStatus="addPayableInfo.objectStatus"
                  :objectStatusId="addPayableInfo.objectStatusConfDictId"
                  :objectName="addPayableInfo.objectName"
                  :objectNameId="addPayableInfo.objectNameId"
                  :isJyForm="false"
                  :objectStatusDataList="objectStatusOptions"
                  :objectNameOptions="objectNameOptionsList"
                  @returnData="returnObjectData"
              ></objectComponentsN>
              <!-- <objectComponents
                label="结算对象："
                :objectStatus="addPayableInfo.objectStatus"
                :objectStatusId="addPayableInfo.objectStatusConfDictId"
                :objectName="addPayableInfo.objectName"
                :isJyForm="false"
                @returnData="returnObjectData"
              ></objectComponents> -->
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="费项：" prop="itemCategoryId" >
                <div style="display: flex; width: 60%;">
                  <el-select
                      clearable
                      v-model="addPayableInfo.itemCategoryId"
                      @visible-change="addPayableVisibleChange($event, 3)"
                      @change="onSelectItemCategoryName"
                      placeholder="费项类型"
                  >
                    <el-option
                        v-for="(item, index) in itemcategoryTypeOptions"
                        :key="index"
                        :label="item.categoryName"
                        :value="item.itemCategoryId"
                    />
                    <!-- itemcategoryTypeOptions -->
                  </el-select>
                  <el-select
                      v-model="addPayableInfo.itemServiceId"
                      :disabled="!addPayableInfo.itemCategoryId"
                      placeholder="费项"
                      @visible-change="addPayableVisibleChange($event, 4)"
                      @change="onSelectItemServiceName"
                      style="margin-left: 10px"
                      clearable
                  >
                    <el-option
                        v-for="(item, index) in itemServiceOptions"
                        :key="index"
                        :label="item.title"
                        :value="item.itemServiceId"
                    />
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="金额：" prop="amount">
                <el-input
                    type="number"
                    v-model="addPayableInfo.amount"
                    placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="结算币种：" prop="currency">
                <el-select
                    clearable
                    v-model="addPayableInfo.currency"
                    placeholder="请选择"
                    @visible-change="addPayableVisibleChange($event, 5)"
                    @change="changeCurrency"
                >
                  <el-option
                      v-for="(item, index) in currencyOptions"
                      :key="index"
                      :label="item.cnName"
                      :value="item.cnName"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="付款方式：" prop="paymentMethodConfDictId">
                <el-select
                    clearable
                    v-model="addPayableInfo.paymentMethodConfDictId"
                    placeholder="请选择"
                    @visible-change="addPayableVisibleChange($event, 6)"
                    @change="onSelectPaymentMethod"
                >
                  <el-option
                      v-for="(item, index) in paymentMethodOptions"
                      :key="index"
                      :label="item.val"
                      :value="item.confDictId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item label="备注：">
                <el-input
                    v-model="addPayableInfo.remarks"
                    placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="上传：">
                <uploadimgs
                    @input="dialogChangeFileList"
                    :fileNameLists="dialogFileNameLists"
                    :limit="99"
                    listType="picture-card"
                ></uploadimgs>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </Dialog>
    </div>



  </div>
</template>

<script>
import { Api } from "@/assets/js/api";
import tools from "@/assets/js/tool";
import utils from "@/assets/js/tool";
import MathNumBer from "@/assets/js/MathNumBer";
// 详情页排版通用组件
import AngleDouble from '@/components/details/angleDouble.vue';
import objectComponentsN from '@/components/objectComponents/indexNew.vue'
import uploadimgs from "@/components/upLoadImgs.vue";
import { Message as ElMessage, MessageBox as ElMessageBox } from "element-ui";
export default {
  components: {
    AngleDouble,
    objectComponentsN,
    uploadimgs
  },
  inject: ["reload"],
  data() {
    return {
      documentStatus: "", //来源单号
      documentNumber: "", //来源单号
      datas: {
        documentStatus: "", //来源单号
        documentNumber: "", //来源单号
        postCode: "", //邮编
        billingWeight: "", //结算重量
        sumWeight: "", //打包重量
        channelName: "",
        packComment: "", //打包备注
        comment: "", //修改备注
        country: "",
        divisor: "",
        dataVolume: "",
        sumVolume: "", //打包体积
        sumCount: "", //
        standardFree: "", //
        nickName: "", //
        memberId: "", //
        otherFree: "", //
        // otherUnitPrice: "", //
        settlementAmount: "", //
        storageName: "", //
        channelNumber: "", //转单号
        agentName: "", //渠道代理
        agentId: "", //渠道代理id
        updateFreight: "", //修改运费
        totalReceivable: "", //修改运费
      },
      agentList: [],
      tableData2: [],
      itemServiceList: [],
      showOtherFee: false,
      showOtherFee2: false,
      formInline: {
        amount: "",
        financeServiceId: "",
        // isDelete: "1", //是否可以删除   0==否,1==是
        itemServiceId: "",
        serviceName: "",
      },
      editData: {
        amount: "",
        financeServiceId: "",
        itemServiceId: "",
        serviceName: "",
      },
      allPrice: 0,
      // financeInId: "", //应收id
      param_s: "", //传过来的参数
      financialInformationTable: [],
      dialogFileNameLists: [],
      feiYongTit: '添加费用',
      dialogVisible : false,
      isClickBtns : false,
      addPayableInfo: {
        financeItemServiceId: "", //财务费项id
        billItemServiceTableId: "", //财务费项id
        itemCategoryId: "", //费项类型id
        itemCategoryName: "", //费项类型
        itemServiceId: "", //费项id
        itemServiceName: "", //费项
        unitPrice: "", //单价
        amount: "", //总计金额
        currency: "", //币种
        currencyId: "", //币种
        objectStatusConfDictId: "", //结算对象类型
        objectStatus: "", //结算对象类型名称
        objectName: "", //结算对象
        objectNameId: "", //结算对象id
        objectNumber: "", //结算对象编号
        paymentMethodConfDictId: "", //付款方式id
        paymentMethod: "", //付款方式
        isPosting: 0, //审核
        isPostingShow: "未审核",
        remarks: "", //备注
        createUser: "", //操作人
        updateTime: "", //操作时间
        files: [],
        oldFiles: [],
        subFiles: [],
        operationType: "",
      },
      selectTabledataList: [],
      financialInformationIndex: 0,
      pageStatus: "edit",
      addPayableInfoRules:{
        objectStatusConfDictId: [
          { required: true, message: "必填", trigger: "change" },
        ],
        itemCategoryId: [{ required: true, message: "必填", trigger: "change" }],
        amount: [{ required: true, message: "必填", trigger: "change" }],
        currency: [{ required: true, message: "必填", trigger: "change" }],
        paymentMethodConfDictId: [
          { required: true, message: "必填", trigger: "change" },
        ],
      },
      objectNameOptionsList: [],
      paymentMethodOptions: [],
      itemServiceOptions: [],
      documentStatusOptionsList: [],
      documentBillOptionsList: [],
      currencyOptions: [],
      itemcategoryTypeOptions: [],
      objectStatusOptions: [],
    };
  },
  watch: {

  },
  created() {
    // let param = this.$route.query || "";
    // if (param) {
    //   this.param_s = param;
    //   this.getDetails();
    // }
    let param2 = {
      directionStatus: "shou:direction_status", //费项类型 shou:direction_status=收 fu:direction_status=付
      title: "", //费项名称
    };
    //获取应收费项
    Api.itemServiceListAll(param2).then((res) => {
      this.itemServiceList = res.data.result || [];
    });
    this.addPayableVisibleChange(true, 1);
  },
  mounted() {
    this.documentStatus = "";
    this.documentNumber = "";
    this.datas = {};
    this.financialInformationTable = [];
  },
  activated() {
    let param = this.$route.query || "";
    if (param.pageType && param.pageType == "newpage") {
      this.param_s = param;
      this.datas.documentStatus = param.documentStatus;
      this.datas.documentNumber = param.documentNumber;
      // this.getDetails();
    }
  },
  methods: {
    getDetails() {
      let p = {
        documentStatus:
          this.param_s.documentStatus || "bill_storepack_v1%3Adocument_status",
        financeInId: this.param_s.financeInId || "",
      };
      if (!p.financeInId) {
        return;
      }
      Api.financeStorepackDetail(this.param_s).then((res) => {
        let datas = res.data.result;
        this.datas = datas;
      });
    },


    //关闭当前页面,跳转指定页面
    closeTab() {
      let arrs = JSON.parse(window.sessionStorage.editableTabs);
      arrs.forEach((item, index) => {
        if (item.path === "/Finance/modifyFee") {
          arrs.splice(index, 1);
        }
      });
      window.sessionStorage.setItem("editableTabs", JSON.stringify(arrs));
      this.$router.push("/Finance/ReceivableBilling");
      this.reload();
    },

    otherDia() {
      this.showOtherFee = true;
      Api.financeInOtherServiceList({
        financeInId: this.param_s.financeInId,
      }).then((res) => {
        this.tableData2 = res.data.result || [];
      });
    },
    handleClose() {
      this.showOtherFee = false;
    },
    handleClose2() {
      this.showOtherFee2 = false;
    },

    editBtn(e) {
      this.showOtherFee2 = true;
      this.editData = this.tableData2[e];
    },

    async onAddFeiYong(){
      this.dialogFileNameLists = [];
      this.feiYongTit = "添加费用";
      this.dialogVisible = true;

      const res1 = await utils.getSelectData("", 4);
      this.currencyOptions = res1.arr;

      // 默认装柜费项
      await utils.getSelectData("item_category_choose_list", 1).then((res) => {
        this.itemcategoryTypeOptions = res.arr;

      });
    },

    addPayableCancel(){
      this.dialogVisible = false;
    },
    addPayableConfirm(){
      if (this.isClickBtns) {
        return false;
      }
      this.isClickBtns = true;
      setTimeout(() => {
        this.isClickBtns = false;
      }, 1000);

      if (!this.addPayableInfo.objectStatusConfDictId) {
        ElMessage({
          message: "结算对象类型必选",
          type: "error",
        });
        return false;
      }
      if (!this.addPayableInfo.objectName) {
        ElMessage({
          message: "结算对象必选",
          type: "error",
        });
        return false;
      }
      if (!this.addPayableInfo.itemCategoryId) {
        ElMessage({
          message: "费项类型必选",
          type: "error",
        });
        return false;
      }
      if (!this.addPayableInfo.itemServiceId) {
        ElMessage({
          message: "费项必选",
          type: "error",
        });
        return false;
      }
      if (!this.addPayableInfo.amount) {
        ElMessage({
          message: "金额必填",
          type: "error",
        });
        return false;
      }
      if (!this.addPayableInfo.currency) {
        ElMessage({
          message: "币种必填",
          type: "error",
        });
        return false;
      }
      if (!this.addPayableInfo.paymentMethodConfDictId) {
        ElMessage({
          message: "付款方式必选",
          type: "error",
        });
        return false;
      }
      this.addPayableInfo.subFiles = [];
      if (this.feiYongTit === "添加费用") {
        if (this.addPayableInfo.files && this.addPayableInfo.files.length > 0) {
          this.addPayableInfo.files.forEach((item, key) => {
            item.fileName = "";
            item.fileId = item.name;
            if (item.status === "ready") {
              this.addPayableInfo.files.splice(key, 1);
            }
          });
          this.addPayableInfo.files.forEach((item, key) => {
            item.fileName = item.name;
            item.fileId = item.name;
            item.operationType = "ADD";
          });
        }
        this.addPayableInfo.subFiles = this.addPayableInfo.files;
        this.addPayableInfo.operationType = "ADD";
        let arrs = [this.addPayableInfo];
        this.onSaveCaiwu(JSON.parse(JSON.stringify(arrs)));
      } else {
        this.addPayableInfo.files.forEach((item, key) => {
          item.fileName = item.name;
          item.fileId = item.name;
        });
        // 新附件this.addPayableInfo.files和原来的附件this.addPayableInfo.oldFiles作对比,
        // 如果fileName一致的, 则把operationType设置为 UPDATE,
        // 如果新附件fileName不在原来的附件中,则把operationType设置为 ADD,
        // 如果原来的附件在新的附件中没有, 则把operationType设置为 DEL
        const newFiles = this.addPayableInfo.files || [];
        const oldFiles = this.addPayableInfo.oldFiles || [];

        // 为新文件设置操作类型
        newFiles.forEach(newFile => {
          const oldFile = oldFiles.find(file => file.fileName === newFile.fileName);
          if (oldFile) {
            // 文件名一致，更新操作
            newFile.operationType = "UPDATE";
          } else {
            // 新文件，添加操作
            newFile.operationType = "ADD";
          }
        });

        // 检查需要删除的旧文件
        oldFiles.forEach(oldFile => {
          const newFile = newFiles.find(file => file.fileName === oldFile.fileName);
          if (!newFile) {
            // 旧文件在新文件中不存在，需要删除
            oldFile.operationType = "DEL";
            newFiles.push(oldFile);
          }
        });
        this.addPayableInfo.subFiles = newFiles;


        this.addPayableInfo.operationType = "UPDATE";
        let arrs = [this.addPayableInfo];
        this.onSaveCaiwu(JSON.parse(JSON.stringify(arrs)));
      }
    },

    async onSaveCaiwu(lists){
      // let lists = financialInformationTable.value;
      let obj = {
        documentStatus: this.documentStatus,
        documentNumber: this.documentNumber,
        itemServiceDatas: lists,
      };
      await Api.financeInSave(obj).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (utils.jyCheckObjectType(data) === "Object") {

            if("success"===data.status){
              this.dialogVisible = false;
              let paramArr = [];
              let objA = {
                conditonKey: "documentStatus",
                conditonVal: this.documentStatus,
              };
              let objB = {
                conditonKey: "documentNumber",
                conditonVal: this.documentNumber,
              };
              paramArr.push(objA)
              paramArr.push(objB)

              // 刷新财务表格
              this.onGetFinancialInformationData(paramArr);
            }
            ElMessage({
              message: data.message,
              type: data.status,
            });

          }
        }
      });
    },

    async onGetFinancialInformationData(params){
      // 财务信息
      let params3 = {
        conditionReqs: params,
        number: "finance_item_service_detail_itemservice",
      };
      let caiWuXinXiList = [];
      await Api.runReport(params3).then((res) => {
        const data = res.data;
        if (data.status === "success") {
          let result = data.result;
          const datas = result.datas;
          if (utils.jyCheckObjectType(datas) === "Array") {
            caiWuXinXiList = datas;
          }
        }
      });

      // 财务信息附件
      let params3_1 = {
        conditionReqs: params,
        number: "finance_item_service_detail_itemservice_files",
      };
      let caiWuXinXiFuJianList = [];
      await Api.runReport(params3_1).then((res) => {
        const data = res.data;
        if (data.status === "success") {
          let result = data.result;
          const datas = result.datas;
          if (utils.jyCheckObjectType(datas) === "Array") {
            caiWuXinXiFuJianList = datas;
          }
        }
      });

      caiWuXinXiList.forEach((value, key) => {
        let arr = [];
        caiWuXinXiFuJianList.forEach((item, index) => {
          if (value.id === item.financeItemServiceId) {
            item.name = item.fileId;
            item.operationType = "UPDATE";
            item.status = "success";
            arr.push(item);
          }
        });
        value.files = arr;
        value.oldFiles = JSON.parse(JSON.stringify(arr));
      });
      this.financialInformationTable = caiWuXinXiList;
    },


    handleSelectionChange(e){
      this.selectTabledataList = e;
    },
    async onCaiwuQdSp(row){
      if (this.isClickBtns) {
        return false;
      }
      this.isClickBtns = true;
      setTimeout(() => {
        this.isClickBtns = false;
      }, 1000);

      let ids = [];
      if (row) {
        const rowData = row.row;
        ids = [rowData.financeItemServiceId];
      } else {
        if (this.selectTabledataList.length < 1) {
          ElMessage({
            message: "请选择审核费项",
            type: "warning",
          });
          return false;
        }
        ids = this.selectTabledataList.map((item) => {
          return item.financeItemServiceId;
        });
      }

      let obj = {
        billItemServiceTableIds: ids,
      };
      await Api.examFinanceInService(obj).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (utils.jyCheckObjectType(data) === "Object") {
            if("success"===data.status){
              // 更新财务表格数据
              let paramArr = [];
              let objA = {
                conditonKey: "documentStatus",
                conditonVal: this.documentStatus,
              };
              let objB = {
                conditonKey: "documentNumber",
                conditonVal: this.documentNumber,
              };
              paramArr.push(objA)
              paramArr.push(objB)
              this.onGetFinancialInformationData(paramArr);
            }

            ElMessage({
              message: data.message,
              type: data.status,
            });
          }
        }
      });
    },
    async onYsfyEditFun(itm, idx){
      const itmRow = itm.row;
      this.financialInformationIndex = idx;
      this.addPayableInfo.financeItemServiceId = itmRow.financeItemServiceId;
      this.addPayableInfo.billItemServiceTableId = itmRow.financeItemServiceId;
      this.addPayableInfo.itemCategoryId = itmRow.itemCategoryId;
      this.addPayableInfo.itemCategoryName = itmRow.itemCategoryName;
      this.addPayableInfo.itemServiceId = itmRow.itemServiceId;
      this.addPayableInfo.itemServiceName = itmRow.itemServiceName;
      this.addPayableInfo.amount = itmRow.amount;
      this.addPayableInfo.currency = itmRow.currency;
      this.addPayableInfo.currencyId = itmRow.currencyId;
      this.addPayableInfo.objectStatusConfDictId = itmRow.objectStatusConfDictId + "";
      this.addPayableInfo.objectStatus = itmRow.objectStatus;
      this.addPayableInfo.objectName = itmRow.objectName;
      this.addPayableInfo.objectNameId = itmRow.objectNameId;
      this.addPayableInfo.objectNumber = itmRow.objectNumber;
      this.addPayableInfo.paymentMethodConfDictId = itmRow.paymentMethodConfDictId + "";
      this.addPayableInfo.paymentMethod = itmRow.paymentMethod;
      this.addPayableInfo.isPosting = itmRow.isPosting;
      this.addPayableInfo.isPostingShow = itmRow.isPostingShow;
      this.addPayableInfo.remarks = itmRow.remarks;
      this.addPayableInfo.createUser = itmRow.createUser;
      this.addPayableInfo.itemId = itmRow.id;
      this.addPayableInfo.updateTime = "";
      this.addPayableInfo.files = itmRow.files;
      this.addPayableInfo.oldFiles = JSON.parse(JSON.stringify(itmRow.files));

      if (utils.jyCheckObjectType(itmRow.files) === "Array") {
        if (itmRow.files.length > 0) {
          for (let obj of itmRow.files) {
            if (obj.fileId) {
              Api.getFileUrl({ fileName: obj.fileId }).then((res) => {
                let filse = res.data.result || {};
                if (filse.url) {
                  obj.url = filse.url;
                } else {
                  ElMessage({
                    message: "附件地址获取失败",
                    type: "error",
                  });
                }
              });
            }
          }
          this.addPayableInfo.files = itmRow.files;
          this.addPayableInfo.oldFiles = JSON.parse(JSON.stringify(itmRow.files));
          this.dialogFileNameLists = itmRow.files;
        } else {
          this.addPayableInfo.files = [];
          this.addPayableInfo.oldFiles = [];
          this.dialogFileNameLists = [];
        }
      } else {
        this.addPayableInfo.files = [];
        this.addPayableInfo.oldFiles = [];
        this.dialogFileNameLists = [];
      }
      await this.addPayableVisibleChange(true, 3);
      await this.addPayableVisibleChange(true, 4);
      await this.addPayableVisibleChange(true, 5);
      await this.addPayableVisibleChange(true, 6);
      this.feiYongTit = "编辑费用";
      this.dialogVisible = true;
      this.objectNameOptionsList = [];
      this.objectStatusOptions.forEach((item) => {
        if (item.confDictId === this.addPayableInfo.objectStatusConfDictId) {
          if (item.keyType === "customer:object_status") {
            // 会员
            utils.getSelectData("member_down_list", 9).then((res) => {
              this.objectNameOptionsList = res.arr;
              this.objectNameOptionsList.forEach((itemA) => {
                if (itemA.userMemberName === this.addPayableInfo.objectName) {
                  this.addPayableInfo.objectNameId = itemA.userMemberId;
                }
              });
            });
          }  else if (item.keyType === "dept:object_status") {
            // 部门
            utils.getSelectData("dept_choose_list", 1).then((res) => {
              this.objectNameOptionsList = res.arr;
              this.objectNameOptionsList.forEach((itemA) => {
                if (itemA.storageName === this.addPayableInfo.objectName) {
                  this.addPayableInfo.objectNameId = itemA.storageId;
                }
              });
            });
          }else if (item.keyType === "storage:object_status") {
            // 仓库
            utils.getSelectData("storage_choose_list", 1).then((res) => {
              this.objectNameOptionsList = res.arr;
              this.objectNameOptionsList.forEach((itemA) => {
                if (itemA.storageName === this.addPayableInfo.objectName) {
                  this.addPayableInfo.objectNameId = itemA.storageId;
                }
              });
            });
          } else if (item.keyType === "channel:object_status") {
            // 合作商
            utils.getSelectData("partner_channel_choose_list", 1).then((res) => {
              this.objectNameOptionsList = res.arr;
              this.objectNameOptionsList.forEach((itemA) => {
                if (itemA.partnerName === this.addPayableInfo.objectName) {
                  this.addPayableInfo.objectNameId = itemA.id;
                }
              });
            });
          } else if (item.keyType === "employee:object_status") {
            // 员工
            utils.getSelectData("employee_choose_list", 1).then((res) => {
              this.objectNameOptionsList = res.arr;
              this.objectNameOptionsList.forEach((itemA) => {
                if (itemA.objectName === this.addPayableInfo.objectName) {
                  this.addPayableInfo.objectNameId = itemA.objectId;
                }
              });
            });
          } else if (item.keyType === "ship_airlines:object_status") {
            // 航空公司
            utils.getSelectData("ship_airlines_choose_list", 1).then((res) => {
              this.objectNameOptionsList = res.arr;
              this.objectNameOptionsList.forEach((itemA) => {
                if (itemA.companyName === this.addPayableInfo.objectName) {
                  this.addPayableInfo.objectNameId = itemA.id;
                }
              });
            });
          }
        }
      });
    },

    async onCaiwuQxSp(row){
      if (this.isClickBtns) {
        return false;
      }
      this.isClickBtns = true;
      setTimeout(() => {
        this.isClickBtns = false;
      }, 1000);

      let ids = [];
      if (row) {
        const rowData = row.row;
        ids = [rowData.financeItemServiceId];
      } else {
        if (this.selectTabledataList.length < 1) {
          ElMessage({
            message: "请选择取消审核的费项",
            type: "warning",
          });
          return false;
        }
        ids = this.selectTabledataList.map((item) => {
          return item.financeItemServiceId;
        });
      }

      let obj = {
        billItemServiceTableIds: ids,
      };
      await Api.cancelExamFinanceInService(obj).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (utils.jyCheckObjectType(data) === "Object") {
            if("success"===data.status){
              // 更新财务表格数据
              let paramArr = [];
              let objA = {
                conditonKey: "documentStatus",
                conditonVal: this.documentStatus,
              };
              let objB = {
                conditonKey: "documentNumber",
                conditonVal: this.documentNumber,
              };
              paramArr.push(objA)
              paramArr.push(objB)
              this.onGetFinancialInformationData(paramArr);
            }

            ElMessage({
              message: data.message,
              type: data.status,
            });
          }
        }
      });
    },

    async delGoods(row){
      if (this.isClickBtns) {
        return false;
      }
      this.isClickBtns = true;
      setTimeout(() => {
        this.isClickBtns = false;
      }, 1000);

      let ids = [];
      if (row) {
        const rowData = row.row;
        ids = [rowData.financeItemServiceId];
      } else {
        if (this.selectTabledataList.length < 1) {
          ElMessage({
            message: "请选择删除的费项",
            type: "warning",
          });
          return false;
        }
        ids = this.selectTabledataList.map((item) => {
          return item.financeItemServiceId;
        });
      }

      let obj = {
        billItemServiceTableIds: ids,
      };
      await Api.delFinanceInService(obj).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (utils.jyCheckObjectType(data) === "Object") {
            if("success"===data.status){
              // 更新财务表格数据
              let paramArr = [];
              let objA = {
                conditonKey: "documentStatus",
                conditonVal: this.documentStatus,
              };
              let objB = {
                conditonKey: "documentNumber",
                conditonVal: this.documentNumber,
              };
              paramArr.push(objA)
              paramArr.push(objB)
              this.onGetFinancialInformationData(paramArr);
            }

            ElMessage({
              message: data.message,
              type: data.status,
            });
          }
        }
      });
    },

    returnObjectData(
        objectInfo,
        objectStatusOptions,
        objectNameOptions){
      this.addPayableInfo.objectStatus = objectInfo.objectStatus;
      this.addPayableInfo.objectStatusConfDictId = objectInfo.objectStatusId;
      this.addPayableInfo.objectName = objectInfo.objectName;
      this.addPayableInfo.objectNumber = objectInfo.objectNumber;
      this.addPayableInfo.objectNameId = objectInfo.objectNameId;
    },
    async addPayableVisibleChange(val, type){
      if (val) {
        if (type === 1) {
          utils.getSelectData("object_status", 3).then((res) => {
            this.objectStatusOptions = res.arr;
          });
        } else if (type === 5) {
          utils.getSelectData("", 4).then((res) => {
            this.currencyOptions = res.arr;
          });
        } else if (type === 6) {
          utils.getSelectData("settlement_method", 3).then((res) => {
            this.paymentMethodOptions = res.arr;
          });
        } else if (type === 3) {
          utils.getSelectData("item_category_choose_list", 1).then((res) => {
            this.itemcategoryTypeOptions = res.arr;
          });
        } else if (type === 4) {
          utils
              .getSelectData("item_service_choose_list", 1, [
                {
                  conditonKey: "itemCategoryId",
                  conditonVal: this.addPayableInfo.itemCategoryId,
                },
              ])
              .then((res) => {
                this.itemServiceOptions = res.arr;
              });
        } else if (type === 2) {
          utils
              .getSelectData({ key: "ship_airlines", type: "object_status" }, 5)
              .then((res) => {
                this.objectNameOptions = res.arr;
              });
        }
      }
    },
    onSelectPaymentMethod(val){
      let arr = this.paymentMethodOptions.filter((value, index) => {
        return value.confDictId === val;
      });
      this.addPayableInfo.paymentMethod = arr[0].val;
    },
    dialogChangeFileList(array){
      if (utils.jyCheckObjectType(array) === "Array") {
        let flists = [];
        let listA = JSON.parse(JSON.stringify(array));

        listA.forEach((item) => {
          if (item.status === "ready") {
          } else {
            flists.push(item);
          }
        });
        this.addPayableInfo.files = flists;
        this.dialogFileNameLists = flists;
      }
    },
    changeCurrency(val){
      this.currencyOptions.forEach((item) => {
        if (item.cnName === val) {
          this.addPayableInfo.currencyId = item.currencyId;
        }
      });
    },
    onSelectItemServiceName(val){
      let arr = this.itemServiceOptions.filter((value, index) => {
        return value.itemServiceId === val;
      });
      this.addPayableInfo.itemServiceName = arr[0].title;
    },
    onSelectItemCategoryName(val){
      let arr = this.itemcategoryTypeOptions.filter((value, index) => {
        return value.itemCategoryId === val;
      });
      this.addPayableInfo.itemCategoryName = arr[0].categoryName;
    },
    saveBtn(){

    },
    saveBtn2(){

    },
    async visibleChange(val, type) {
      if (val) {
        if (type === 1) {
          await utils.getSelectData("down_list_finance_item_service_document_status", 1).then((res) => {
            this.documentStatusOptionsList = res.arr;
          });
        }else if (type === 2) {
          if("package_v1:document_status" === this.documentStatus){
            await Api.runPageReport({
              number: "down_list_package",
              pageStart: 1,
              pageTotal: 20,
            })
                .then((res) => {
                  let datas = res.data.result.datas.data || [];
                  this.documentBillOptionsList = datas;
                });
          }else if("bill_pack_v1:document_status" === this.documentStatus){
            await Api.runPageReport({
              number: "down_list_bill_pack",
              pageStart: 1,
              pageTotal: 20,
            })
                .then((res) => {
                  let datas = res.data.result.datas.data || [];
                  this.documentBillOptionsList = datas;
                });
          }
        }
      }
    },
    async changeDocumentStatus(e){
      this.datas.documentNumber = "";
      this.documentNumber = "";
      this.datas =  {};
      if("package_v1:document_status" === e){
        await Api.runPageReport({
          number: "down_list_package",
          pageStart: 1,
          pageTotal: 20,
        })
            .then((res) => {
              let datas = res.data.result.datas.data || [];
              this.documentBillOptionsList = datas;
            });
      }else if("bill_pack_v1:document_status" === e){
        await Api.runPageReport({
          number: "down_list_bill_pack",
          pageStart: 1,
          pageTotal: 20,
        })
            .then((res) => {
              let datas = res.data.result.datas.data || [];
              this.documentBillOptionsList = datas;
            });
      }
    },
    async getDocumentBillOptionsList(val){
      let param = {
        conditonKey: "billNumber",
        conditonVal: val,
      };
      if("package_v1:document_status" === this.documentStatus){
        await Api.runPageReport({
          conditionReqs: [param],
          number: "down_list_package",
          pageStart: 1,
          pageTotal: 20,
        })
            .then((res) => {
              let datas = res.data.result.datas.data || [];
              this.documentBillOptionsList = datas;
            });
      }else if("bill_pack_v1:document_status" === this.documentStatus){
        await Api.runPageReport({
          conditionReqs: [param],
          number: "down_list_bill_pack",
          pageStart: 1,
          pageTotal: 20,
        })
            .then((res) => {
              let datas = res.data.result.datas.data || [];
              this.documentBillOptionsList = datas;
            });
      }
    },

    async changeDocumentNumber(e){
      if(!e)
        return;
      this.documentNumber = e;
      this.datas =  {};
      //查询详情
      if("bill_pack_v1:document_status" === this.documentStatus){
        let obj = {
          conditonKey: "number",
          conditonVal: e,
        }
        let param = {
          conditionReqs: [obj],
          number : "finance_item_service_bill_pack_detail",
        };
        Api.runReport(param).then((res) => {
          if (res.status === 200) {
            const data = res.data;
            if (data.status === "success") {
              let result = data.result;
              const datas = result.datas;
              if(utils.jyCheckObjectType(datas)==="Array"){
                this.datas = datas[0];
              }

            }
          } else {

          }
        });
      }else if("package_v1:document_status" === this.documentStatus){
        let obj = {
          conditonKey: "number",
          conditonVal: e,
        }
        let param = {
          conditionReqs: [obj],
          number : "finance_item_service_package_detail",
        };
        Api.runReport(param).then((res) => {
          if (res.status === 200) {
            const data = res.data;
            if (data.status === "success") {
              let result = data.result;
              const datas = result.datas;
              if(utils.jyCheckObjectType(datas)==="Array"){
                this.datas = datas[0];
              }

            }
          } else {

          }
        });
      }
      let paramArr = [];
      let objA = {
        conditonKey: "documentStatus",
        conditonVal: this.documentStatus,
      };
      let objB = {
        conditonKey: "documentNumber",
        conditonVal: e,
      };
      paramArr.push(objA)
      paramArr.push(objB)
      await this.onGetFinancialInformationData(paramArr);
    },

  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-dialog__footer {
    text-align: center;
  }
}
.formbox {
  width: 80%;
  min-width: 800px;
  margin: 20px auto;
  //   padding: 10px 30px;
  box-sizing: border-box;
  //   display: flex;

  .formDisplay {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    ::v-deep {
      .el-form-item {
        margin-bottom: 0;
      }
      .el-input.is-disabled .el-input__inner {
        color: #666;
      }
    }

    .beizhuBox {
      width: 100%;
      margin-top: 30px;
      ::v-deep {
        .el-form-item__content {
          width: calc(100% - 150px);
        }
      }
      // .inputText {
      //     width: calc(100% - 150px);
      // }
    }
    .otherFee {
      ::v-deep {
        .el-form-item__label {
          color: #f00;
        }
      }
    }

    .queryItem1 {
      // min-width: 300px;
      width: 30%;
      margin: 4px 0;
      border: 1px solid #cccccc;
      border-radius: 5px;
      display: flex;
      align-items: center;

      ::v-deep {
        .el-form-item__content {
          width: calc(100% - 100px);
          line-height: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .el-input__inner {
          line-height: 28px;
          height: 28px;
          border: none;
        }
        .el-form-item__label {
          line-height: 30px;
        }
        .el-select {
          width: 100%;
        }
      }

      .input {
        width: 100%;
        height: 30px;
      }
    }
    .queryItem_dia {
      width: 44%;
    }
    .queryTextare {
      width: calc(100% - 100px);
      display: flex;
      align-items: center;
      margin-top: 20px;
      border: 1px solid #d7d7d7;
      box-sizing: border-box;
      margin-right: 0;

      ::v-deep {
        .el-form-item__content {
          width: calc(100% - 100px);
        }
        .el-textarea__inner {
          border: none;
        }
      }
    }
  }

  .form_fq {
    margin-top: 20px;
  }

  .inpu {
    width: 180px;
  }
  .inpu1 {
    width: 210px;
  }
}

.formbox ::v-deep {
  .el-button {
    padding: 7px 10px !important;
  }
}

.btn_e6a23c {
  background-color: #e6a23c;
  color: #fff;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
}
</style>
